import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import WarningIcon from 'spypoint/src/assets/icons/WarningIcon'
import Grid from '@material-ui/core/Grid'
import VoskerSecondaryButton from 'spypoint/src/components/buttons/VoskerSecondaryButton'

const useStyles = makeStyles(theme => ({
  paper: {
    padding: '64px 40px',
    border: '1px solid #5D5A5A',
    background: 'none',
    [theme.breakpoints.down('xs')]: {
      margin: '31px 9px 0px 9px',
      padding: '40px 20px',
    },
  },
  container: {
    maxWidth: '1000px',
    padding: 0,
    [theme.breakpoints.down('1050')]: {
      with: '100%',
      padding: '0px',
      margin: '31px 16px 0px 16px',
    },
    [theme.breakpoints.down('xs')]: {
      with: '100%',
      padding: '0px',
      margin: '31px 9px 0px 9px',
    },
  },
  title: {
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '150%',
    letterSpacing: '0px',
  },
  paragraph: {
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '150%',
    letterSpacing: '0px',
    padding: '0 12px',
  },
  description: {
    fontSize: '.95rem',
  },
  icon: {
    paddingRight: '10px',
  },
  mobileButtonWrap: {
    padding: '24px 0 0 12px',
    display: 'flex',
  },
  mobileButton: {
    height: '28px',
    textAlign: 'center',
    padding: '7px 16px',
    gap: '10',
    border: '1px solid #5D5A5A',
    borderRadius: 6,
    color: theme.palette.secondary.main,
    background: 'none',
    '& > span': {
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '100%',
      letterSpacing: '0px',
      color: `${theme.palette.secondary.main} !important`,
      '&:hover': {
        color: `${theme.palette.basic.lightGrey} !important`,
      },
    },
    '&:hover': {
      background: 'none',
      border: `1px solid ${theme.palette.basic.lightGrey}`,
    },
  },
  titleDescriptionContainer: {
    display: 'flex',
    padding: '0 12px',
  },
}))
const PlanMissingUi = () => {
  const { t } = useTranslation()

  const classes = useStyles()
  const history = useHistory()

  const title = t('app:photo_transmition_plan.plans.plans_unavailable.title')
  const description = t('app:photo_transmition_plan.plans.plans_unavailable.text')
  const buttonText = t('app:photo_transmition_plan.plans.plans_unavailable.button')

  const refreshPage = () => {
    history.go(0)
  }

  return (
    <Container maxWidth="md" component="div" className={classes.container}>
      <Paper className={classes.paper}>
        <Grid container size={12}>
          <Grid className={classes.titleDescriptionContainer} item size={12}>
            <Grid className={classes.icon}>
              <WarningIcon />
            </Grid>
            <Grid>
              <Typography className={classes.title}>{ title }</Typography>
            </Grid>
          </Grid>
          <Grid className={classes.paragraph} item size={12}>
            <Typography component="div">{ description }</Typography>
          </Grid>
          <Grid item className={classes.mobileButtonWrap} size={12}>
            <VoskerSecondaryButton
              size="small"
              onClick={refreshPage}
              className={classes.mobileButton}
            >
              { buttonText }
            </VoskerSecondaryButton>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  )
}

export default PlanMissingUi
